const fmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Los_Angeles',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

/** Today's YYYY-MM-DD in the business timezone (America/Los_Angeles). */
export function getBusinessDateString(date: Date = new Date()): string {
  return fmt.format(date)
}

const hourFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Los_Angeles',
  hour: '2-digit',
  hourCycle: 'h23',
})

/** Hour of day (0-23) in the business timezone (America/Los_Angeles). */
export function getBusinessHour(date: Date = new Date()): number {
  return Number(hourFmt.format(date))
}
